<template>
  <v-container class="ma-0 pa-0" width="100%">
    <!-- list app bar-->
    <v-container
      v-if="!secondary"
      flat
      dense
      class="ma-0 pa-0 d-flex justify-space-between"
      width="100%"
      height="45"
    >
      <!-- right side-->
      <v-container class="pa-0 ma-0 d-flex gap-2 right">
        <FlexibleAutocomplete
          v-if="!isDisable"
          v-model="workshop"
          title="workshop"
          type="WorkshopType"
          :multiple="false"
          :currency="currencyId"
          :fetchData="fetchWorkshopApi"
          :error="workshopError"
          :required="true"
        />
        <template>
          <v-text-field
            id="IdYear"
            v-model="Year"
            :label="$t('year_')"
            outlined
            dense
            clearable
            :error="yearError"
            :disabled="isDisable"
            :readonly="isDisable"
          />

          <date-picker
            v-model="Year"
            element="IdYear"
            locale="fa,en"
            auto-submit
            type="year"
            format="jYYYY"
            simple
            :disabled="isDisable"
            :color="
              $vuetify.theme.themes[$vuetify.theme.isDark ? 'dark' : 'light'].primary
            "
          />
        </template>
        <template>
          <v-text-field
            id="IdMonth"
            v-model="Month"
            :label="$t('month')"
            outlined
            dense
            clearable
            :error="monthError"
            :disabled="isDisable"
            :readonly="isDisable"
          />

          <date-picker
            v-model="Month"
            element="IdMonth"
            locale="fa,en"
            auto-submit
            type="month"
            format="jMM"
            simple
            :disabled="isDisable"
            :color="
              $vuetify.theme.themes[$vuetify.theme.isDark ? 'dark' : 'light'].primary
            "
          />
        </template>
      </v-container>
      <!-- left side-->
      <v-container class="pa-0 ma-0 d-flex right">
        <v-menu offset-y v-if="isMobile || isTablet">
          <template v-slot:activator="{ attrs, on }">
            <v-btn
              outlined
              class="px-1"
              color="grey darken-2"
              height="32"
              v-bind="attrs"
              v-on="on"
              style="min-width: 35px !important; padding: 0 !important"
            >
              <v-icon> mdi-dots-vertical </v-icon>
            </v-btn>
          </template>
          <v-list dense>
            <!-- <v-list-item link @click="OpenDialog"> -->
            <!-- <v-list-item-icon>
                <v-icon>mdi-plus</v-icon>
              </v-list-item-icon> -->
            <!-- <v-list-item-title v-text="$t('received_from_rollCall')" /> -->
            <!-- </v-list-item> -->
            <v-list-item link @click="OpenDialogSeverance">
              <!-- <v-list-item-icon>
                <v-icon>mdi-plus</v-icon>
              </v-list-item-icon> -->
              <v-list-item-title v-text="$t('severance_Calc')" />
            </v-list-item>
            <v-list-item link @click="OpenDialog">
              <!-- <v-list-item-icon>
                <v-icon>mdi-plus</v-icon>
              </v-list-item-icon> -->
              <v-list-item-title v-text="$t('Eid_Calc')" />
            </v-list-item>
          </v-list>
        </v-menu>
        <!-- <v-btn
          outlined
          v-if="!isMobile && !isTablet"
          @click="openVideo"
          class="ms-2 pa-0"
          color="primary"
          height="32"
        >
          {{ $t("received_from_rollCall") }}
          <v-icon color="primary"> mdi-plus </v-icon>
        </v-btn> -->
        <v-btn
          outlined
          v-if="!isMobile && !isTablet"
          @click="OpenDialogSeverance"
          class="ms-2 pa-0"
          color="primary"
          height="32"
        >
          {{ $t("severance_Calc") }}
          <v-icon color="primary"> mdi-plus </v-icon>
        </v-btn>
        <v-btn
          outlined
          v-if="!isMobile && !isTablet"
          @click="OpenDialog"
          class="ms-2 pa-0"
          color="primary"
          height="32"
        >
          {{ $t("Eid_Calc") }}
          <v-icon color="primary"> mdi-plus </v-icon>
        </v-btn>
        <!-- <v-btn
          v-if="!isMobile && !isTablet"
          outlined
          @click="OpenDialog"
          class="ms-2 pa-0"
          color="primary"
          height="32"
        >
          {{ $t("Eid_Calc") }}

          <v-icon color="#fff"> mdi-plus </v-icon>
        </v-btn> -->
      </v-container>
    </v-container>

    <!-- secondary app bar-->
    <v-container
      v-if="secondary && !third"
      flat
      dense
      class="ma-0 pa-0 d-flex justify-space-between"
      width="100%"
      height="45"
    >
      <!-- right side-->
      <v-container class="pa-0 ma-0 d-flex right">
        <v-toolbar-title class="ma-0 pa-0 mt-1">{{
          titleProp ? $t(titleProp) : $t($route.name, { name: $store.state.studentLabel })
        }}</v-toolbar-title>
        <v-text-field
          class="ms-2"
          v-if="!isMobile && !isTablet"
          style="width: 230px"
          v-model="search"
          append-icon="mdi-magnify"
          clearable
          :label="$t('search')"
          flat
          outlined
          dense
        />
      </v-container>
      <!-- left side-->
      <v-container class="pa-0 ma-0 d-flex right">
        <v-menu offset-y v-if="isMobile || isTablet">
          <template v-slot:activator="{ attrs, on }">
            <v-btn
              outlined
              class="px-1"
              color="grey darken-2"
              height="32"
              v-bind="attrs"
              v-on="on"
              style="min-width: 35px !important; padding: 0 !important"
            >
              <v-icon> mdi-dots-vertical </v-icon>
            </v-btn>
          </template>
          <v-list dense>
            <v-list-item link @click="getItems">
              <v-list-item-icon>
                <v-icon>mdi-refresh</v-icon>
              </v-list-item-icon>
              <v-list-item-title v-text="$t('refresh')" />
            </v-list-item>
            <v-list-item link>
              <export-excel
                ref="refExcel"
                :data="baseData"
                worksheet="abriron.com"
                name="data.xls"
                type="xls"
                class="d-flex align-center w-100"
                :title="$store.state.abrName"
                :total-prop="pageCount"
                :page-prop="excelPage"
                @getAllRows="getAllRows"
              >
                <v-list-item-icon>
                  <v-icon>mdi-file-excel-outline</v-icon>
                </v-list-item-icon>
                <v-list-item-title>{{ $t("excel") }}</v-list-item-title>
              </export-excel>
            </v-list-item>
            <v-list-item v-if="isMobile || isTablet" link @click="printDialog = true">
              <v-list-item-icon>
                <v-icon>mdi-printer-outline</v-icon>
              </v-list-item-icon>
              <v-list-item-title v-text="$t('print')" />
            </v-list-item>
            <v-list-item link @click="goToWorkshop">
              <v-list-item-icon>
                <v-icon>mdi-plus</v-icon>
              </v-list-item-icon>
              <v-list-item-title v-text="$t('add_salery_operations')" />
            </v-list-item>
          </v-list>
        </v-menu>

        <v-btn
          v-if="!isMobile && !isTablet"
          @click="getItems"
          outlined
          class="px-1 ms-2 pa-0"
          color="grey darken-2"
          height="32"
          @shortkey="getItems"
          v-shortkey="['f5']"
          style="min-width: 35px !important; padding: 0 !important"
        >
          <v-icon> mdi-refresh </v-icon>
        </v-btn>
        <export-excel
          v-if="!isMobile && !isTablet"
          ref="refExcel"
          :data="baseData"
          worksheet="abriron.com"
          name="data-ai.xls"
          type="xls"
          class="float-left pa-0 ma-0"
          :title="$store.state.abrName"
          :total-prop="pageCount"
          :page-prop="excelPage"
          @getAllRows="getAllRows"
        >
          <v-btn outlined class="ma-0 ms-2" color="grey darken-2 " height="32">
            <p class="font-weight-thin mb-0 pa-a me-2">
              {{ $t("excel") }}
            </p>
            <v-icon> mdi-file-excel-outline </v-icon>
          </v-btn>
        </export-excel>
        <v-btn
          v-if="!isMobile && !isTablet"
          outlined
          @click="printDialog = true"
          class="ms-2 pa-0"
          color="grey darken-2"
          height="32"
        >
          <p class="font-weight-thin mb-0 me-2">
            {{ $t("print") }}
          </p>
          <v-icon> mdi-printer-outline </v-icon>
        </v-btn>
        <v-btn
          v-if="!isMobile && !isTablet"
          @click="goToWorkshop"
          class="ms-2 pa-0"
          color="primary"
          height="32"
        >
          {{ $t("add_salery_operations") }}

          <v-icon color="#fff"> mdi-plus </v-icon>
        </v-btn>
      </v-container>
    </v-container>
    <!-- Third app bar-->
    <v-container
      v-if="secondary && third"
      flat
      dense
      class="ma-0 pa-0 d-flex justify-space-between"
      width="100%"
      height="45"
    >
      <!-- right side-->
      <v-container class="pa-0 ma-0 d-flex right">
        <v-toolbar-title class="ma-0 pa-0 mt-1 ml-1">{{
          titleProp ? $t(titleProp) : $t($route.name, { name: $store.state.studentLabel })
        }}</v-toolbar-title>
        <v-card-text
          v-if="status == 'pending' && status != null"
          class="pa-0 px-2 ma-0 mt-1 text-body-2"
          style="
            border: 1px solid #fddee3;
            border-radius: 4px;
            display: flex;
            align-items: center;
            justify-content: center;
            background-color: #f7c2ca;
            color: #c62828;
          "
        >
          {{ $t("awaitingApproval") }}
        </v-card-text>

        <v-card-text
          v-if="status == 'done' && status != null"
          class="pa-0 ma-0 mt-1 text-body-2"
          style="
            border: 1px solid #bef3c2;
            border-radius: 4px;
            display: flex;
            align-items: center;
            justify-content: center;
            background-color: #bef3c2;
            color: #2e7d32;
          "
        >
          {{ $t("confirmed") }}
        </v-card-text>
      </v-container>
      <!-- left side-->
      <v-container class="pa-0 ma-0 d-flex right">
        <v-menu offset-y v-if="isMobile || isTablet">
          <template v-slot:activator="{ attrs, on }">
            <v-btn
              outlined
              class="px-1"
              color="grey darken-2"
              height="32"
              v-bind="attrs"
              v-on="on"
              style="min-width: 35px !important; padding: 0 !important"
            >
              <v-icon> mdi-dots-vertical </v-icon>
            </v-btn>
          </template>
          <v-list dense>
            <v-list-item link @click="goToEditoperations">
              <v-list-item-title v-text="$t('edit')" />
            </v-list-item>
            <v-list-item link v-if="status == 'done'" @click="saveAndReturn">
              <v-list-item-title v-text="$t('review_and_Edit')" />
            </v-list-item>
            <v-list-item v-if="status == 'pending'" link @click="saveAndReturn">
              <v-list-item-title v-text="$t('submitAndRegister')" />
            </v-list-item>
          </v-list>
        </v-menu>
        <v-btn
          v-if="!isMobile && !isTablet"
          outlined
          @click="goToEditoperations"
          class="ms-2 pa-0"
          color="primary"
          height="32"
        >
          {{ $t("edit") }}
        </v-btn>
        <v-btn
          v-if="!isMobile && !isTablet && status == 'pending'"
          @click="saveAndReturn"
          class="ms-2 pa-0"
          color="primary"
          height="32"
        >
          {{ $t("submitAndRegister") }}
        </v-btn>
        <v-btn
          v-if="!isMobile && !isTablet && status == 'done'"
          @click="saveAndReturn"
          class="ms-2 pa-0"
          color="primary"
          height="32"
        >
          {{ $t("review_and_Edit") }}
        </v-btn>
      </v-container>
    </v-container>
    <!--excel dialog-->
    <v-dialog
      v-model="printDialog"
      :fullscreen="isMobile"
      :hide-overlay="isMobile"
      width="90%"
    >
      <v-card>
        <v-col class="d-flex pb-0">
          <v-btn icon color="grey darken-2" @click="printDialog = false">
            <v-icon class="close-hover" large> mdi-close </v-icon>
          </v-btn>
          <p class="mx-auto font-weight-medium mt-2">
            {{ $t("print") }}
          </p>
        </v-col>
        <v-row class="ma-0">
          <printnew
            ref="printRef"
            :header-prop="printHeaders"
            :showSumRowProp="false"
            :items-prop="items"
            :dialog="printDialog"
            :title="$t($route.name)"
          />
        </v-row>
        <v-card-actions />
      </v-card>
    </v-dialog>
    <!--  snackbar --->
    <v-snackbar
      v-model="snakbar"
      :color="snakbarColor ? snakbarColor : 'primary'"
      top
      style="z-index: 1000000000000 !important"
    >
      {{ snakbarText }}

      <template v-slot:action="{ attrs }">
        <v-btn
          :loading="loading"
          color="white"
          text
          v-bind="attrs"
          @click="snakbar = !snakbar"
        >
          {{ $t("close") }}
        </v-btn>
      </template>
    </v-snackbar>
  </v-container>
</template>
<script>
import moment from "moment-jalaali";
import mixin from "../../../../../../Mixins/mixin";
import general from "../../../../../../Mixins/general";
import autocomplete from "../../../../components/general/patial/autocomplete";
import FlexibleAutocomplete from "../../../../components/general/patial/FlexibleAutocomplete.vue";

export default {
  name: "appBarOperation",
  mixins: [mixin, general],
  components: {
    autocomplete,
    FlexibleAutocomplete,
  },
  props: {
    secondary: {
      type: Boolean,
      default: false,
    },
    third: {
      type: Boolean,
      default: false,
    },
    edit: {
      type: Boolean,
      default: false,
    },
    saleryOptions: {
      type: Object,
      default: () => {},
    },
    isDisabled: {
      type: Boolean,
      default: true,
    },
    salaryFactorItems: {
      type: Object,
      default: () => {},
    },
    validate: {
      type: Boolean,
      default: true,
    },
    beSelected: {
      type: Boolean,
      default: false,
    },
    loader: {
      type: Boolean,
      default: false,
    },
  },
  data: () => ({
    titleProp: "",
    printHeaders: "",
    currencyId: null,
    name: null,
    search: null,
    printDialog: false,
    baseData: null,
    pageCount: null,
    excelPage: null,
    isDisable: false,
    workshopError: false,
    yearError: false,
    monthError: false,
    loading: false,
    snakbar: false,
    snakbarColor: null,
    snakbarText: null,
    workshop: null,
    Year: null,
    Month: null,
    id: null,
    status: null,
    items: [],
  }),
  watch: {
    validate(val) {
      if (!val) {
        this.checkRequired(false);
      }
    },
    name(val) {
      this.$emit("name-change", val);
    },
    workshop: {
      deep: true,
      handler(val) {
        this.emitSelectedData();
      },
    },
    Month: {
      deep: true,
      handler(val) {
        this.emitSelectedData();
      },
    },
    Year: {
      deep: true,
      handler(val) {
        this.emitSelectedData();
      },
    },
    isDisabled: {
      deep: true,
      handler(val) {
        this.isDisable = val;
      },
    },
    saleryOptions: {
      deep: true,
      handler(val) {
        if (!val) return;
        let obj = JSON.parse(JSON.stringify(val));
        this.Year = obj.year || "";
        this.Month = obj.month || "";
      },
    },
    salaryFactorItems: {
      deep: true,
      handler(val) {
        if (val) {
          let obj = JSON.parse(JSON.stringify(val));
          const data = (obj.items.data || []).map((item) => ({
            ...item,
            workshop_name: item.workshop?.name || "",
            month: item.month || "",
            year: item.year || "",
          }));
          this.items = data || [];
          this.baseData = data || [];
          this.pageCount = obj.items?.last_page || 0;
          this.excelPage = obj.items?.current_page || 1;
          this.status = obj.items?.workshop?.status || null;
          this.workshop = obj.items?.workshop?.hrm_workshop_id || null;
          this.id = obj.items?.workshop?.id || null;
          this.Year = obj.items?.workshop?.year || null;
          this.Month = obj.items?.workshop?.month || null;
        }
      },
    },
    loader: {
      deep: true,
      handler(val) {
        if (val) {
          this.loading = val;
        }
      },
    },
    beSelected: {
      deep: true,
      handler(val) {
        if (val) {
          this.checkRequired(true);
        }
      },
    },
  },
  beforeMount() {
    this.printHeaders = [
      { text: this.$t("id"), value: "id" },
      { text: this.$t("workshop"), value: "workshop.name" },
      { text: this.$t("countPersonnel"), value: "employee_count" },
      { text: this.$t("year_"), value: "year" },
      { text: this.$t("Month"), value: "month" },
    ];
  },
  methods: {
    emitSelectedData() {
      if (!this.workshop) return;
      const wid = this.workshopIdValue();
      const payload = {
        workshop_id: wid != null && wid !== "" ? wid : null,
        year: this.Year || null,
        month: this.Month || null,
      };
      this.$emit("saleryOperation-options", payload);
    },
    fetchWorkshopApi(payload) {
      var app = this;
      let params = {
        page: payload.page,
        search: payload.search || "",
        options: JSON.stringify({
          itemsPerPage: 10,
        }),
        currency: app.currencyId,
      };
      return app.$axios
        .get(app.$endpoint + "workshop", { params })
        .then(function (response) {
          let list = response && response.data.data ? response.data.data : [];
          if (list.length && !app.workshop) {
            app.workshop = list[0];
          }
          return {
            items: list,
            hasMore: list.length === 10,
          };
        });
    },
    workshopIdValue() {
      const w = this.workshop;
      if (w == null) return null;
      return typeof w === "object" && w !== null && "id" in w ? w.id : w;
    },
    checkRequired(val) {
      var app = this;
      if (val) {
        app.snakbarText = app.$t("at_least_selected_effectiveWork");
        app.snakbarColor = "red";
        app.snakbar = true;
        app.$emit("update_value");
        return;
      }
      const wid = app.workshopIdValue();
      app.workshopError = wid == null || wid === "";
      const yearStr =
        app.Year == null || app.Year === "" ? "" : String(app.Year).trim();
      const monthStr =
        app.Month == null || app.Month === "" ? "" : String(app.Month).trim();
      app.yearError = yearStr === "";
      app.monthError = monthStr === "";
      const hasError = app.workshopError || app.yearError || app.monthError;
      if (hasError) {
        app.snakbarText = app.$t("is-required");
        app.snakbarColor = "red";
        app.snakbar = true;
        app.$emit("update_value");
        return false;
      }
      app.workshopError = false;
      app.yearError = false;
      app.monthError = false;
      return true;
    },
    generateTime(val) {
      let format = "jYYYY/jMM/jDD";
      let date = val;
      if (!date) return null;
      return moment(date).locale("fa").format(format);
    },
    OpenDialog() {
      this.$emit("open-dialog");
    },
    OpenDialogSeverance() {
      this.$emit("open-dialog-severance");
    },
    goToWorkshop() {
      this.$router.push("/payroll/salery_operations/create");
    },
    goToEditoperations() {
      this.$router.push({
        name: "edit_salery_operations",
        query: {
          id: this.id,
          hrm_workshop_id: this.workshop,
          year: this.Year,
          month: this.Month,
        },
      });
    },
    saveAndNew() {
      this.$emit("click-save-and-new");
    },
    saveAndReturn() {
      this.$emit("click-save-and-return");
    },
    openFilters() {
      this.$emit("open-filters");
    },
    getItems() {
      this.$emit("get-items");
    },
  },
};
</script>
<style scoped>
.right {
  width: auto;
}
</style>
